__turbopack_context__.v({
  "lds-dual-ring": "Spinner-module-scss-module__vIla9q__lds-dual-ring",
  "textsizespinner": "Spinner-module-scss-module__vIla9q__textsizespinner",
});
